import { HttpErrorResponse } from '@angular/common/http'
import { Observable, of, OperatorFunction } from 'rxjs'
import { Action } from '@ngrx/store'
import { alertError, empty } from '@adex/store/actions/global.actions'
import { catchError, mergeMap, tap } from 'rxjs/operators'


export function buildErrorMessage(error: Error): string {
  console.error(error)
  let message = 'ERROR_MESSAGES.'
  if (error instanceof HttpErrorResponse) {
    const text = error?.error?.errors?.map(t => t.text).join(' /n')
    if (text) message = text
    else message += `NETWORK_ERROR.ERROR_${ error.status }`
  }
  return message
}

export function buildAlertErrorStream(error: Error): Observable<Action> {
  if ('status' in error && Reflect.get(error, 'status') === 401) return of(empty())
  return of(alertError({ message: buildErrorMessage(error) }))
}

export function catchErrorAlert(actions: any[] = []): OperatorFunction<any, Action> {
  return catchError(err => buildAlertErrorStream(err).pipe(
    mergeMap(alert => [
      alert,
      ...actions
    ])
  ))
}

export function catchErrorLog(actions: any[] = []): OperatorFunction<any, Action> {
  return catchError(err => of(actions).pipe(
    tap(() => console.error(err)),
    mergeMap(() => [ ...actions ])
  ))
}
